export enum BannerType {
  Desktop = 1,
  Mobile = 2,
  SideDashboard = 4,
}
